import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectSalesOrder = state => {
    return selectOwnState(state).salesOrder
}

export const selectShipmentList = state => {
    const salesOrder = selectSalesOrder(state)
    return salesOrder ? salesOrder.shipmentList : []
}

export const selectSentEmailList = state => {
    const salesOrder = selectSalesOrder(state)
    return salesOrder ? salesOrder.sentEmailList : []
}

export const selectInvoiceList = state => {
    const salesOrder = selectSalesOrder(state)
    return salesOrder ? salesOrder.invoiceList : []
}

export const selectPaymentList = state => {
    const salesOrder = selectSalesOrder(state)
    return salesOrder ? salesOrder.paymentList : []
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectSalesOrderCustomer = state => {
    const salesOrder = selectSalesOrder(state)
    return salesOrder ? salesOrder.salesOrderCustomer : null
}

export const selectSalesOrderCustomerContact = state => {
    return selectOwnState(state).contact
}

export const selectAPIError = state => {
    return selectOwnState(state).error
}



// WEBPACK FOOTER //
// ./src/modules/sales-order/state/detail/selector.js